import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { isTwoColumn } from '@outdoor-voices/ui/dist/utils/dom/isMobile';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { RESIZE } from '../../config/constants';
import JumperButtons from '../JumperButtons';
import ProductSet from './ProductSet';
import ProductSetWithoutTitle from './ProductSetWithoutTitle';
import slugify from '../../utils/strings/slugify';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Collection = function Collection(_ref) {
  var collection = _ref.collection;

  var _useState = useState(isTwoColumn()),
      _useState2 = _slicedToArray(_useState, 2),
      isMobile = _useState2[0],
      setIsMobile = _useState2[1];

  var _useState3 = useState(-1),
      _useState4 = _slicedToArray(_useState3, 2),
      currentIndex = _useState4[0],
      setCurrentIndex = _useState4[1];

  var _collection$propertie = collection.properties,
      gridDisplayEditorial = _collection$propertie.gridDisplayEditorial,
      gridDisplaySwatches = _collection$propertie.gridDisplaySwatches;
  var productSets = collection.productSets;
  var nav = document.querySelector('.ov-nav');
  var navHeight = nav && nav.offsetHeight ? nav.offsetHeight : 0;
  var buttons = productSets.filter(function (productSet) {
    return productSet.jumpLink !== '';
  }).map(function (productSet) {
    return {
      title: productSet.jumpLink,
      slug: slugify(productSet.jumpLink)
    };
  });
  useEffect(function () {
    if (window.location.hash && document.querySelector("a[href=\"".concat(window.location.hash, "\"]"))) {
      document.querySelector("a[href=\"".concat(window.location.hash, "\"]")).click();
    }
  }, []);
  useEffect(function () {
    var onResize = function onResize() {
      var newIsMobile = isTwoColumn();

      if (newIsMobile === isMobile) {
        return;
      }

      setIsMobile(newIsMobile);
    };

    window.addEventListener(RESIZE, onResize);
    return function () {
      window.removeEventListener(RESIZE, onResize);
    };
  }, [isMobile]);

  var onJumperClick = function onJumperClick(idx) {
    var targetEl = document.querySelector("#product-set-".concat(idx));
    window.scrollTo({
      top: targetEl.offsetTop - navHeight - 80,
      behavior: 'smooth'
    });
  };

  var index = -1;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [buttons.length > 1 && /*#__PURE__*/_jsx(JumperButtons, {
      buttons: buttons,
      currentIndex: currentIndex,
      onClick: onJumperClick
    }), productSets.map(function (productSet) {
      if (productSet.title) {
        index += 1;
        return /*#__PURE__*/_createElement(ProductSet, _objectSpread(_objectSpread({}, productSet), {}, {
          displaySwatches: gridDisplaySwatches,
          displayEditorial: gridDisplayEditorial,
          index: index,
          isMobile: isMobile,
          key: productSet.id,
          setCurrentIndex: setCurrentIndex
        }));
      }

      return /*#__PURE__*/_createElement(ProductSetWithoutTitle, _objectSpread(_objectSpread({}, productSet), {}, {
        displaySwatches: gridDisplaySwatches,
        displayEditorial: gridDisplayEditorial,
        isMobile: isMobile,
        key: productSet.id
      }));
    })]
  });
};

Collection.defaultProps = {
  displayEditorial: false
};
Collection.propTypes = {
  collection: PropTypes.shape({
    properties: PropTypes.shape({
      banner: PropTypes.shape({}),
      filters: PropTypes.string,
      gridDisplayEditorial: PropTypes.bool,
      gridDisplaySwatches: PropTypes.bool,
      toolbarDisplay: PropTypes.bool,
      toolbarDisplaySort: PropTypes.bool
    }),
    productSets: PropTypes.arrayOf(PropTypes.shape())
  }).isRequired,
  displayEditorial: PropTypes.bool
};
export default Collection;